import env from '../../../../../env';
import { OutgoingOrderModal as component1 } from "./installations/1/OutgoingOrderModal";
import { OutgoingOrderModal as component2 } from "./installations/2/OutgoingOrderModal";
import { OutgoingOrderModal as component3 } from "./installations/3/OutgoingOrderModal";
import { OutgoingOrderModal as component4 } from "./installations/4/OutgoingOrderModal";
import { OutgoingOrderModal as component6 } from "./installations/6/OutgoingOrderModal";
import { OutgoingOrderModal as component7 } from "./installations/7/OutgoingOrderModal";
import { AppClientId } from "../../../../Shared/constants";

let component = component1;
switch (env.clientId) {
  case AppClientId.INDEWAL: component = component1;
    break;
  case AppClientId.IDWLEASE: component = component1;
    break;
  case AppClientId.HARRY_NIJBOER: component = component2;
    break;
  case AppClientId.HOOIKAMMER: component = component3;
    break;
  case AppClientId.IDW_GMBH: component = component4;
    break;
  case AppClientId.AUTOWIENTJES: component = component6;
    break;
    case AppClientId.AUTOHUISSALLAND: component = component7;
    break;
}

export const OutgoingOrderModal = component;
